class ProductMembershipOffer extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = this.querySelector('.purchase-option__add-to-cart-button');
    this.cart = document.querySelector('cart-drawer');
    this.variantId = this.dataset.variantId;
    this.sellingPlanId = this.dataset.sellingPlanId;
    this.discountCode = this.dataset.discountCode;

    this.frequencySelect = this.querySelector('select.frequencies');
    this.frequencySelect?.addEventListener('change', (event) => {
      this.sellingPlanId = event.target.selectedOptions[0].dataset.sellingPlanId;
    });

    this.addToCartButton.addEventListener('click', () => {
      this.addToCart();
    });
  }

  async addToCart() {
    this.addToCartButton.setAttribute('disabled', 'disabled');
    this.addToCartButton.classList.add('loading');
    this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      const formData = this.#buildFormData();
      const standardCart = new StandardCart(this, formData);
      const cart = await standardCart.addToCart();

      if (cart && this.discountCode) {
        const codes = cart.discount_codes.map((object) => object.code);
        if (!codes.includes(this.discountCode)) {
          await standardCart.updateCartDiscounts([...codes, this.discountCode]);
        }
      }
    } catch (error) {
      console.error('Error adding subscription to cart:', error);
    } finally {
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
      this.addToCartButton.removeAttribute('disabled');
    }
  }

  #buildFormData() {
    const formData = new FormData();
    formData.append('id', this.variantId);
    if (this.sellingPlanId) {
      formData.append('selling_plan', this.sellingPlanId);
    }
    return formData;
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart },
        }),
      );
      return cart;
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
    return null;
  }
}

if (!customElements.get('product-membership-offer')) {
  customElements.define('product-membership-offer', ProductMembershipOffer);
}
